import PatientAppointmentDetails from '../../services/general/appointmentData.api'

const getRawData = (result) => {
  if (!result) return []
  let d = result.d !== undefined ? result.d : result
  if (typeof d === 'string') {
    try {
      d = JSON.parse(d)
    } catch (e) {
      return []
    }
  }
  return d?.Data || (Array.isArray(d) ? d : [])
}

const safeParseDetails = (details) => {
  if (!details) return []
  if (typeof details !== 'string') return details
  try {
    return JSON.parse(details)
  } catch (e) {
    return []
  }
}

// All three public appointment helpers read the same endpoint. Consumers that
// need both shapes should use this snapshot so one refresh does not create
// multiple identical network requests.
export const getAllAppointmentsSnapshot = async (getType, param1, param2) => {
  try {
    const result = await PatientAppointmentDetails(getType, '', param1, param2, '')
    const rawData = getRawData(result)
    const appointmentData = rawData.flatMap((item) => safeParseDetails(item?.AppointmentDetails))
    const appointmentDetails = appointmentData
      .flatMap((item) => item?.appointmentDetails || [])
      .filter((item) => item && Object.keys(item).length > 0)

    return { appointmentData, appointmentDetails }
  } catch (error) {
    console.log('Error in getAppointmentData', error)
    return { appointmentData: [], appointmentDetails: [] }
  }
}

export const getAllAppointments = async (getType, param1, param2) => {
  try {
    const result = await PatientAppointmentDetails(getType, '', param1, param2, '')
    const rawData = getRawData(result)

    let structuredData = rawData.flatMap((item) => safeParseDetails(item?.AppointmentDetails))
    return structuredData || []
  } catch (error) {
    console.log('Error in getAppointmentData', error)
    return []
  }
}

export const getAllAppointmentsDetails = async (getType, param1, param2) => {
  try {
    const result = await PatientAppointmentDetails(getType, '', param1, param2, '')
    const rawData = getRawData(result)
    
    let structuredData = rawData.flatMap((item) => safeParseDetails(item?.AppointmentDetails))

    let AppointmentDetails = structuredData.flatMap((p) => p?.appointmentDetails || [])

    let validAppointments = AppointmentDetails.filter((item) => item && Object.keys(item).length > 0)

    console.log('validAppointments---->', validAppointments, AppointmentDetails)

    return validAppointments || []
  } catch (error) {
    console.log('Error in getAppointmentData', error)
    return []
  }
}

export const getScheduledAppointment = async (getType, param1, param2) => {
  try {
    const result = await PatientAppointmentDetails(getType, '', param1, param2, '')
    const rawData = getRawData(result)

    let structuredData = rawData.flatMap((item) => safeParseDetails(item?.AppointmentDetails))

    let scheduledPatient = structuredData.flatMap((p) => p?.appointmentDetails || [])
    scheduledPatient = scheduledPatient.filter((item) => item?.data?.Status === 'Scheduled' || item?.data?.Status === 'Rescheduled')

    return scheduledPatient || []
  } catch (error) {
    console.log('Error in getAppointmentData', error)
    return []
  }
}

export const getAppointmentDataID = async (getType, param1, param2) => {
  try {
    const result = await PatientAppointmentDetails(getType, '', param1, param2, '')
    const rawData = getRawData(result)
    return rawData[0]?.ID || null
  } catch (error) {
    console.log('Error in getAppointmentData', error)
    return null
  }
}
